import { useState, FormEvent } from "react";
import { hizmetler } from "@/mocks/hizmetler";

interface RandevuPopupProps {
  onClose: () => void;
}

const saatler = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
  "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
];

function getTodayStr() {
  return new Date().toISOString().split("T")[0];
}

export default function RandevuPopup({ onClose }: RandevuPopupProps) {
  const [adim, setAdim] = useState<1 | 2>(1);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [adSoyad, setAdSoyad] = useState("");
  const [telefon, setTelefon] = useState("");
  const [hizmet, setHizmet] = useState("");
  const [tarih, setTarih] = useState("");
  const [saat, setSaat] = useState("");
  const [not, setNot] = useState("");

  const adim1Gecerli = adSoyad.trim().length > 1 && telefon.trim().length >= 10;

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!adim1Gecerli || !hizmet || !tarih || !saat) return;
    setLoading(true);

    const data = new URLSearchParams();
    data.append("Ad Soyad", adSoyad);
    data.append("Telefon", telefon);
    data.append("Hizmet", hizmet);
    data.append("Tarih", tarih);
    data.append("Saat", saat);
    if (not.trim()) data.append("Not", not);

    try {
      await fetch("https://readdy.ai/api/form/d791goqdqn9mib2tqukg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
    } catch {
      // silent
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center px-4">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-[#1A0F0A]/75 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Popup Box */}
      <div
        className="relative w-full max-w-lg rounded-2xl border border-[#E8B86D]/20 overflow-hidden"
        style={{
          background: "#1E1008",
          animation: "popupIn 0.35s cubic-bezier(0.34,1.56,0.64,1) both",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {/* Top accent */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#E8B86D]/60 to-transparent" />

        {/* Header */}
        <div className="px-7 pt-6 pb-4 flex items-start justify-between">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-7 h-7 flex items-center justify-center rounded-full border border-[#E8B86D]/30"
                style={{ background: "rgba(232,184,109,0.12)" }}>
                <i className="ri-calendar-check-line text-[#E8B86D] text-sm" />
              </div>
              <span className="text-[#E8B86D] text-xs font-bold tracking-widest uppercase">Randevu Al</span>
            </div>
            <h3
              className="font-black italic text-white leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.5rem" }}
            >
              {submitted ? "Randevunuz Alındı!" : "Randevu Talep Et"}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full text-white/40 hover:text-white hover:bg-white/10 transition-all cursor-pointer flex-shrink-0 mt-1"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        {/* Adım göstergesi */}
        {!submitted && (
          <div className="px-7 pb-4">
            <div className="flex items-center gap-2">
              {[1, 2].map((s) => (
                <div key={s} className="flex items-center gap-2">
                  <div
                    className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-black transition-all"
                    style={
                      adim >= s
                        ? { background: "linear-gradient(135deg, #C9943A, #E8B86D)", color: "#1A0F0A" }
                        : { background: "rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.3)" }
                    }
                  >
                    {s}
                  </div>
                  <span className={`text-xs ${adim >= s ? "text-white/70" : "text-white/25"}`}>
                    {s === 1 ? "Kişisel Bilgiler" : "Tarih & Hizmet"}
                  </span>
                  {s < 2 && <div className="flex-1 h-px w-8 bg-white/10 mx-1" />}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="px-7 pb-7">
          {submitted ? (
            /* Başarı ekranı */
            <div className="text-center py-6">
              <div
                className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4 border border-[#E8B86D]/30"
                style={{ background: "rgba(232,184,109,0.12)" }}
              >
                <i className="ri-check-line text-3xl text-[#E8B86D]" />
              </div>
              <p className="text-white/60 text-sm font-light leading-relaxed mb-2">
                Randevu talebiniz başarıyla iletildi.
              </p>
              <p className="text-white/40 text-xs font-light mb-6">
                Ekibimiz en kısa sürede sizi arayarak randevunuzu onaylayacak.
              </p>
              <div className="rounded-xl p-4 border border-[#E8B86D]/20 text-left space-y-2 mb-6"
                style={{ background: "rgba(232,184,109,0.06)" }}>
                <div className="flex items-center gap-2 text-xs text-white/55">
                  <i className="ri-user-line text-[#E8B86D]" />
                  <span>{adSoyad}</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-white/55">
                  <i className="ri-scissors-line text-[#E8B86D]" />
                  <span>{hizmet}</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-white/55">
                  <i className="ri-calendar-line text-[#E8B86D]" />
                  <span>{tarih} — {saat}</span>
                </div>
              </div>
              <button
                onClick={onClose}
                className="w-full py-3 rounded-xl font-black text-sm text-[#1A0F0A] cursor-pointer"
                style={{ background: "linear-gradient(135deg, #C9943A, #E8B86D)" }}
              >
                Tamam
              </button>
            </div>
          ) : (
            <form data-readdy-form onSubmit={handleSubmit}>
              {adim === 1 && (
                <div className="space-y-3">
                  {/* Ad Soyad */}
                  <div>
                    <label className="block text-white/50 text-xs mb-1.5 font-medium">Ad Soyad *</label>
                    <input
                      type="text"
                      name="adSoyad"
                      required
                      value={adSoyad}
                      onChange={(e) => setAdSoyad(e.target.value)}
                      placeholder="Adınız ve soyadınız"
                      className="w-full rounded-xl px-4 py-3 text-sm text-white placeholder-white/25 focus:outline-none transition-all border"
                      style={{
                        background: "rgba(255,255,255,0.06)",
                        borderColor: adSoyad ? "rgba(232,184,109,0.4)" : "rgba(255,255,255,0.12)",
                      }}
                    />
                  </div>

                  {/* Telefon */}
                  <div>
                    <label className="block text-white/50 text-xs mb-1.5 font-medium">Telefon *</label>
                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-white/35 text-sm">+90</span>
                      <input
                        type="tel"
                        name="telefon"
                        required
                        value={telefon}
                        onChange={(e) => setTelefon(e.target.value)}
                        placeholder="5XX XXX XX XX"
                        className="w-full rounded-xl pl-12 pr-4 py-3 text-sm text-white placeholder-white/25 focus:outline-none transition-all border"
                        style={{
                          background: "rgba(255,255,255,0.06)",
                          borderColor: telefon ? "rgba(232,184,109,0.4)" : "rgba(255,255,255,0.12)",
                        }}
                      />
                    </div>
                  </div>

                  <button
                    type="button"
                    disabled={!adim1Gecerli}
                    onClick={() => setAdim(2)}
                    className="w-full py-3.5 rounded-xl font-black text-sm transition-all cursor-pointer mt-2 disabled:opacity-40 disabled:cursor-not-allowed"
                    style={{ background: "linear-gradient(135deg, #C9943A, #E8B86D)", color: "#1A0F0A" }}
                  >
                    Devam Et
                    <i className="ri-arrow-right-line ml-2" />
                  </button>
                </div>
              )}

              {adim === 2 && (
                <div className="space-y-3">
                  {/* Hizmet Seçimi */}
                  <div>
                    <label className="block text-white/50 text-xs mb-1.5 font-medium">Hizmet *</label>
                    <div className="relative">
                      <select
                        name="hizmet"
                        required
                        value={hizmet}
                        onChange={(e) => setHizmet(e.target.value)}
                        className="w-full rounded-xl px-4 py-3 text-sm focus:outline-none transition-all border appearance-none cursor-pointer"
                        style={{
                          background: "rgba(255,255,255,0.06)",
                          borderColor: hizmet ? "rgba(232,184,109,0.4)" : "rgba(255,255,255,0.12)",
                          color: hizmet ? "white" : "rgba(255,255,255,0.25)",
                        }}
                      >
                        <option value="" disabled style={{ background: "#1E1008" }}>Hizmet seçin</option>
                        {hizmetler.map((h) => (
                          <option key={h.id} value={h.baslik} style={{ background: "#1E1008", color: "white" }}>
                            {h.baslik}
                          </option>
                        ))}
                        <option value="Diğer / Danışma" style={{ background: "#1E1008", color: "white" }}>
                          Diğer / Danışma
                        </option>
                      </select>
                      <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-white/30 pointer-events-none" />
                    </div>
                  </div>

                  {/* Tarih */}
                  <div>
                    <label className="block text-white/50 text-xs mb-1.5 font-medium">Tarih *</label>
                    <input
                      type="date"
                      name="tarih"
                      required
                      value={tarih}
                      min={getTodayStr()}
                      onChange={(e) => setTarih(e.target.value)}
                      className="w-full rounded-xl px-4 py-3 text-sm text-white focus:outline-none transition-all border cursor-pointer"
                      style={{
                        background: "rgba(255,255,255,0.06)",
                        borderColor: tarih ? "rgba(232,184,109,0.4)" : "rgba(255,255,255,0.12)",
                        colorScheme: "dark",
                      }}
                    />
                  </div>

                  {/* Saat Seçimi */}
                  <div>
                    <label className="block text-white/50 text-xs mb-1.5 font-medium">Saat *</label>
                    <div className="grid grid-cols-6 gap-1.5">
                      {saatler.map((s) => (
                        <button
                          key={s}
                          type="button"
                          onClick={() => setSaat(s)}
                          className="py-2 rounded-lg text-xs font-medium transition-all cursor-pointer border"
                          style={
                            saat === s
                              ? { background: "linear-gradient(135deg, #C9943A, #E8B86D)", color: "#1A0F0A", borderColor: "transparent", fontWeight: 700 }
                              : { background: "rgba(255,255,255,0.05)", color: "rgba(255,255,255,0.5)", borderColor: "rgba(255,255,255,0.1)" }
                          }
                        >
                          {s}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Not (opsiyonel) */}
                  <div>
                    <label className="block text-white/50 text-xs mb-1.5 font-medium">
                      Not <span className="text-white/25">(opsiyonel)</span>
                    </label>
                    <textarea
                      name="not"
                      value={not}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) setNot(e.target.value);
                      }}
                      placeholder="Eklemek istediğiniz bir şey var mı?"
                      rows={2}
                      maxLength={500}
                      className="w-full rounded-xl px-4 py-3 text-sm text-white placeholder-white/25 focus:outline-none transition-all border resize-none"
                      style={{
                        background: "rgba(255,255,255,0.06)",
                        borderColor: "rgba(255,255,255,0.12)",
                      }}
                    />
                    <p className="text-right text-white/20 text-xs mt-1">{not.length}/500</p>
                  </div>

                  <div className="flex gap-2 mt-2">
                    <button
                      type="button"
                      onClick={() => setAdim(1)}
                      className="flex-1 py-3.5 rounded-xl font-semibold text-sm text-white/60 border border-white/15 hover:border-white/30 transition-all cursor-pointer"
                      style={{ background: "rgba(255,255,255,0.05)" }}
                    >
                      <i className="ri-arrow-left-line mr-1" />
                      Geri
                    </button>
                    <button
                      type="submit"
                      disabled={loading || !hizmet || !tarih || !saat}
                      className="flex-[2] py-3.5 rounded-xl font-black text-sm transition-all cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                      style={{ background: "linear-gradient(135deg, #C9943A, #E8B86D)", color: "#1A0F0A" }}
                    >
                      {loading ? (
                        <><i className="ri-loader-4-line animate-spin" /> Gönderiliyor...</>
                      ) : (
                        <><i className="ri-calendar-check-line" /> Randevu Talep Et</>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </form>
          )}
        </div>

        <style>{`
          @keyframes popupIn {
            from { opacity: 0; transform: scale(0.88) translateY(20px); }
            to   { opacity: 1; transform: scale(1) translateY(0); }
          }
        `}</style>
      </div>
    </div>
  );
}
